/**
 * @fileoverview patrol-web's PUBLIC marketing entry — its telemetry bootstrap
 * (UNREACHABLE-MODULE-BURNDOWN-001 Q-UMB-13).
 *
 * Imported FIRST by `main.jsx`, for its side effect: ES imports evaluate before an entry's body, so
 * only a bootstrap imported ahead of `MarketingWebsiteApp` is live when that module evaluates — and
 * a marketing site that fails while loading is exactly the failure worth hearing about.
 *
 * `createAppLogger` is the same one call the app bundle makes (`src/core/config/logger.js`): it
 * captures uncaught errors and unhandled rejections, and collects the Core Web Vitals — which, on
 * this page, wait for the visitor's cookie consent (`<CookieConsentProvider>` governs them). It
 * ships over the entry's fetch seam rather than the app's axios api-client, which the
 * `marketingEntryBarrelFreedom` contract keeps out of the prerendered bundle.
 *
 * @module portals/marketing-website/telemetry
 */

import { createFetchSeam } from '@puffin-core/api-client/fetch-seam';
import { createAppLogger, createFetchLogClient } from '@puffin-core/logging-browser';

createAppLogger({
  app: 'patrol-web',
  surface: 'marketing',
  client: createFetchLogClient({ fetch: createFetchSeam({ label: 'patrolMarketingTelemetry' }) }),
  production: import.meta.env.PROD,
  ship: { endpoint: '/api/v1/telemetry/logs', baseURL: '' },
});
